import React from "react";
import "./Jewellery.css";

import { FaShoppingCart, FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useCart } from "./CartContext";
import { useCountry } from "./CountryContext";

// ======================================
// HERO IMAGE
// ======================================

import heroImage from "../Images/newcollection2.jpg";

// ======================================
// EARRINGS IMAGES
// ======================================

import earring1 from "../Images/blue5.jpg";
import earring2 from "../Images/jewelery11.jpg";
import earring3 from "../Images/jewelery12.jpg";
import earring4 from "../Images/orange8.jpg";
import earring5 from "../Images/jewelery13.jpg";
import earring6 from "../Images/jewelery14.jpg";
import earring7 from "../Images/jewelery15.jpg";
import earring8 from "../Images/jewelery16.jpg";
import earring9 from "../Images/jewelery17.jpg";
import earring10 from "../Images/jewelery18.jpg";
import earring11 from "../Images/jewelery19.jpg";
import earring12 from "../Images/jewelery20.jpg";
import earring13 from "../Images/jewelery21.jpg";
import earring14 from "../Images/jewelery22.jpg";
import earring15 from "../Images/jewelery23.jpg";

// ======================================
// PURSE IMAGES
// ======================================

import purse1 from "../Images/yellow2.jpg";
import purse2 from "../Images/blue4.jpg";
import purse3 from "../Images/yellow1.jpg";
import purse4 from "../Images/purse4.jpg";
import purse5 from "../Images/black1.jpg";
// import purse6 from "../Images/purse6.jpg";
// import purse7 from "../Images/purse7.jpg";
// import purse8 from "../Images/purse1.jpg";

// ======================================
// HEAD CAP IMAGES
// ======================================

import cap1 from "../Images/blue1.jpg";
import cap2 from "../Images/cap6.jpg";
import cap3 from "../Images/cap3.jpg";
import cap4 from "../Images/cap7.jpg";
import cap5 from "../Images/image30.png";
import cap6 from "../Images/cap8.jpg";
import cap7 from "../Images/cap5.jpg";
import cap8 from "../Images/orange4.jpg";

// ======================================
// EARRINGS DATA
// ======================================

const earrings = [
  {
    id: 301,
    image: earring1,
    name: "Golden Statement Earrings",
    price: "£29.99",
  },
  {
    id: 302,
    image: earring2,
    name: "African Beaded Earrings",
    price: "£34.99",
  },
  {
    id: 303,
    image: earring3,
    name: "Elegant Drop Earrings",
    price: "£27.99",
  },
  {
    id: 304,
    image: earring4,
    name: "Classic Gold Earrings",
    price: "£39.99",
  },
  {
    id: 305,
    image: earring5,
    name: "Pearl African Earrings",
    price: "£32.99",
  },
  {
    id: 306,
    image: earring6,
    name: "Luxury Hoop Earrings",
    price: "£36.99",
  },
  {
    id: 307,
    image: earring7,
    name: "Designer Beaded Earrings",
    price: "£31.99",
  },
  {
    id: 308,
    image: earring8,
    name: "Royal Gold Earrings",
    price: "£42.99",
  },
  {
    id: 309,
    image: earring9,
    name: "Royal Gold Earrings",
    price: "£42.99",
  },
  {
    id: 308,
    image: earring10,
    name: "Royal Gold Earrings",
    price: "£42.99",
  },
  {
    id: 308,
    image: earring11,
    name: "Royal Gold Earrings",
    price: "£42.99",
  },
  {
    id: 308,
    image: earring12,
    name: "Royal Gold Earrings",
    price: "£42.99",
  },
  {
    id: 308,
    image: earring13,
    name: "Royal Gold Earrings",
    price: "£42.99",
  },
  {
    id: 308,
    image: earring14,
    name: "Royal Gold Earrings",
    price: "£42.99",
  },
  {
    id: 308,
    image: earring15,
    name: "Royal Gold Earrings",
    price: "£42.99",
  },
  
];

// ======================================
// PURSE DATA
// ======================================

const purses = [
  {
    id: 401,
    image: purse1,
    name: "African Luxury Purse",
    price: "£59.99",
  },
  {
    id: 402,
    image: purse2,
    name: "Classic Leather Purse",
    price: "£64.99",
  },
  {
    id: 403,
    image: purse3,
    name: "Elegant Evening Purse",
    price: "£54.99",
  },
  {
    id: 404,
    image: purse4,
    name: "Handcrafted African Purse",
    price: "£69.99",
  },
  {
    id: 405,
    image: purse5,
    name: "Luxury Mini Purse",
    price: "£49.99",
  },
  // {
  //   id: 406,
  //   image: purse6,
  //   name: "Premium Designer Purse",
  //   price: "£74.99",
  // },
  // {
  //   id: 407,
  //   image: purse7,
  //   name: "Classic Brown Purse",
  //   price: "£57.99",
  // },
  // {
  //   id: 408,
  //   image: purse8,
  //   name: "Statement Fashion Purse",
  //   price: "£79.99",
  // },
];

// ======================================
// HEAD CAP DATA
// ======================================

const headCaps = [
  {
    id: 501,
    image: cap1,
    name: "African Print Head Cap",
    price: "£24.99",
  },
  {
    id: 502,
    image: cap2,
    name: "Traditional African Cap",
    price: "£29.99",
  },
  {
    id: 503,
    image: cap3,
    name: "Luxury Patterned Cap",
    price: "£27.99",
  },
  {
    id: 504,
    image: cap4,
    name: "Classic African Head Cap",
    price: "£31.99",
  },
  {
    id: 505,
    image: cap5,
    name: "Elegant Printed Cap",
    price: "£26.99",
  },
  {
    id: 506,
    image: cap6,
    name: "Royal African Cap",
    price: "£34.99",
  },
  {
    id: 507,
    image: cap7,
    name: "Designer Head Cap",
    price: "£32.99",
  },
  {
    id: 508,
    image: cap8,
    name: "Premium African Cap",
    price: "£36.99",
  },
];

// ======================================
// REUSABLE CAROUSEL
// ======================================

function ProductCarousel({ title, subtitle, products }) {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  // Country / Currency
  const { formatPrice } = useCountry();

  // ======================================
  // GET BASE GBP PRICE
  // ======================================

  const getBasePrice = (price) => {
    const numericPrice = parseFloat(
      String(price).replace("£", "").trim()
    );

    return isNaN(numericPrice) ? 0 : numericPrice;
  };

  // ======================================
  // ADD TO CART
  // ======================================

  const handleAddToCart = (item) => {
    const numericPrice = getBasePrice(item.price);

    addToCart({
      id: item.id,
      name: item.name,
      img: item.image,

      // IMPORTANT:
      // Cart stores base GBP price.
      // Currency conversion happens when displaying.
      price: numericPrice,

      oldPrice: item.price,
    });

    alert(`${item.name} added to cart!`);
  };

  // ======================================
  // BUY NOW
  // ======================================

  const handleBuyNow = (item) => {
    const numericPrice = getBasePrice(item.price);

    addToCart({
      id: item.id,
      name: item.name,
      img: item.image,

      // Base GBP price
      price: numericPrice,

      oldPrice: item.price,
    });

    // Buy Now → Payment
    navigate("/payment");
  };

  return (
    <section className="jewellery-carousel-section">

      {/* ==================================
          SECTION HEADING
      ================================== */}

      <div className="jewellery-section-heading">

        <p>{subtitle}</p>

        <h2>{title}</h2>

        <div className="jewellery-title-line"></div>

      </div>

      {/* ==================================
          CAROUSEL
      ================================== */}

      <div className="jewellery-carousel-wrapper">

        <div className="jewellery-carousel-track">

          {/* ==================================
              FIRST SET
          ================================== */}

          {products.map((item) => (

            <div
              className="jewellery-carousel-card"
              key={item.id}
            >

              {/* IMAGE */}

              <div className="jewellery-card-image">

                <img
                  src={item.image}
                  alt={item.name}
                />

              </div>

              {/* PRODUCT DETAILS */}

              <div className="jewellery-card-content">

                <h4>
                  {item.name}
                </h4>

                {/* ==================================
                    CONVERTED PRICE
                ================================== */}

                <div className="jewellery-product-price">
                  {formatPrice(getBasePrice(item.price))}
                </div>

                {/* BUTTONS */}

                <div className="jewellery-product-buttons">

                  <button
                    className="jewellery-cart-btn"
                    onClick={() =>
                      handleAddToCart(item)
                    }
                  >
                    <FaShoppingCart />
                    <span>Add to Cart</span>
                  </button>

                  <button
                    className="jewellery-buy-btn"
                    onClick={() =>
                      handleBuyNow(item)
                    }
                  >
                    Buy Now
                  </button>

                </div>

              </div>

            </div>

          ))}

          {/* ==================================
              DUPLICATE SET FOR INFINITE LOOP
          ================================== */}

          {products.map((item) => (

            <div
              className="jewellery-carousel-card"
              key={`duplicate-${item.id}`}
            >

              {/* IMAGE */}

              <div className="jewellery-card-image">

                <img
                  src={item.image}
                  alt={item.name}
                />

              </div>

              {/* PRODUCT DETAILS */}

              <div className="jewellery-card-content">

                <h4>
                  {item.name}
                </h4>

                {/* CONVERTED PRICE */}

                <div className="jewellery-product-price">
                  {formatPrice(getBasePrice(item.price))}
                </div>

                {/* BUTTONS */}

                <div className="jewellery-product-buttons">

                  <button
                    className="jewellery-cart-btn"
                    onClick={() =>
                      handleAddToCart(item)
                    }
                  >
                    <FaShoppingCart />
                    <span>Add to Cart</span>
                  </button>

                  <button
                    className="jewellery-buy-btn"
                    onClick={() =>
                      handleBuyNow(item)
                    }
                  >
                    Buy Now
                  </button>

                </div>

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}

// ======================================
// MAIN COMPONENT
// ======================================

function Jewellery() {

  return (

    <div className="jewellery-page">

      {/* ==================================
          HERO SECTION
      ================================== */}

      <section className="jewellery-hero">

        <div className="container">

          <div className="row align-items-center g-4">

            {/* LEFT IMAGE */}

            <div className="col-lg-6">

              <div className="jewellery-hero-image-box">

                <img
                  src={heroImage}
                  alt="African Jewellery and Accessories"
                />

                <div className="jewellery-image-label">
                  AFRIQUE COLLECTION
                </div>

              </div>

            </div>

            {/* RIGHT CONTENT */}

            <div className="col-lg-6">

              <div className="jewellery-hero-content">

                <p className="jewellery-eyebrow">
                  ACCESSORIES COLLECTION
                </p>

                <h1>
                  Jewellery &amp;
                  <br />
                  <span>Accessories</span>
                </h1>

                <div className="jewellery-hero-line"></div>

                <p className="jewellery-description">
                  Discover our curated collection of elegant
                  African accessories, from statement earrings
                  and luxury purses to beautifully crafted head
                  caps designed to complete your look.
                </p>

                <p className="jewellery-description">
                  Every piece brings together culture,
                  craftsmanship and contemporary elegance.
                </p>

                <button className="jewellery-explore-btn">

                  Explore Collection

                  <FaArrowRight />

                </button>

              </div>

            </div>

          </div>

        </div>

      </section>

      {/* ==================================
          EARRINGS
      ================================== */}

      <ProductCarousel
        title="Statement Earrings"
        subtitle="Discover the Details"
        products={earrings}
      />

      {/* ==================================
          PURSES
      ================================== */}

      <ProductCarousel
        title="Luxury Purses"
        subtitle="Carry Your Style"
        products={purses}
      />

      {/* ==================================
          HEAD CAPS
      ================================== */}

      <ProductCarousel
        title="African Head Caps"
        subtitle="Complete Your Look"
        products={headCaps}
      />

    </div>
  );
}

export default Jewellery;

